<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="projectBuildings"
      :items-per-page="10"
      class="elevation-1"
      single-select
      :search="search"
    >
      <template v-slot:top>
        <v-row
          class="mb-0"
          style="border-bottom: 1px solid rgba(255, 255, 255, 0.12)"
        >
          <v-col class="d-flex align-center"> </v-col>
          <v-col cols="2" sm="2" md="2">
            <v-text-field
              dense
              v-model="search"
              append-icon="mdi-magnify"
              outlined=""
              label="Search"
              hide-details
              class="mr-4"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.name="{ item }">
        <tr>
          {{
            item.name
          }}
        </tr>
      </template>
      <template v-slot:item.action="{ item }">
        <!-- <v-icon small class="mr-3" @click="editPois(item.id)"
          >mdi-alpha-p-circle-outline</v-icon
        > -->
        <v-select
          :items="masterplans"
          placeholder="Change building masterplan/community"
          item-text="name"
          item-value="id"
          size="2"
          class="mr-1"
          @change="changeMasterplan($event, item)"
          >edit</v-select
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'BuildingSettings',
  props: {
    projectBuildings: {
      type: Array,
      required: true,
      default: () => []
    },
    context: {
      type: String,
      required: false,
      default: 'building'
    }
  },
  data: function() {
    return {
      masterplans: this.$store.state.MasterplanStore.projectMasterplans,
      search: ''
    }
  },
  computed: {
    headers() {
      this.projectBuildings.forEach(
        e =>
          (e.masterplanName = this.masterplans.find(
            i => i.id === e.masterplansId
          ).name)
      )
      this.projectBuildings.forEach(
        e =>
          (e.communityMasterplan = this.masterplans.find(
            i => i.id === e.masterplansId
          ).community)
      )
      return [
        {
          text: this.context.toUpperCase(),
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'MASTERPLAN/COMMUNITY NAME',
          align: 'left',
          sortable: true,
          value: 'masterplanName'
        },
        {
          text: 'COMMUNITY',
          align: 'left',
          sortable: true,
          value: 'communityMasterplan'
        },
        {
          text: 'CHANGE BUILDING MASTERPLAN/COMMUNITY',
          value: 'action',
          sortable: false,
          align: 'right'
        }
      ]
    }
  },
  watch: {
    '$store.state.BuildingStore.projectBuildings'() {
      return (this.projectBuildings = this.$store.state.BuildingState.projectBuildings)
    }
  },
  methods: {
    changeMasterplan(id, item) {
      this.$store.dispatch('BuildingStore/updateBuilding', {
        id: item.id,
        name: item.name,
        masterplansId: id
      })
    }
  }
}
</script>
